export const uniq = <T>(array?: T[]) => {
  if (!array) return []

  return [...new Set(array)]
}
